/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * @export
 */
export const CreateContactSettingRequestContactSettingKindEnum = {
    SingleField: 'single_field',
    MultipleField: 'multiple_field'
};
export function CreateContactSettingRequestContactSettingFromJSON(json) {
    return CreateContactSettingRequestContactSettingFromJSONTyped(json, false);
}
export function CreateContactSettingRequestContactSettingFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: !exists(json, 'name') ? undefined : json['name'],
        icon: !exists(json, 'icon') ? undefined : json['icon'],
        kind: !exists(json, 'kind') ? undefined : json['kind']
    };
}
export function CreateContactSettingRequestContactSettingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        icon: value.icon,
        kind: value.kind
    };
}
